import { CoursesFilterOption } from './coursesFilters.model';
import {
  CoursesFilterOptionsClient,
  CoursesFiltersClient,
} from './coursesFilters.client';
import { RequestHeader } from '../../../services';
import { AxiosRequestConfig } from 'axios';
import { FiltersModel } from '../../../catalog';

export const coursesFilterOptionsClientProvider = async (
  host: string,
  privateHost: string = '',
  slug: string,
  site?: string,
  additionalHeaders?: RequestHeader,
  requestConfigs?: AxiosRequestConfig
): Promise<CoursesFilterOption[]> => {
  const response = await new CoursesFilterOptionsClient(
    host,
    privateHost,
    slug,
    site,
    additionalHeaders,
    requestConfigs
  ).get();

  return response as unknown as Promise<CoursesFilterOption[]>;
};

export const coursesFiltersClientProvider = async (
  host: string,
  privateHost: string = '',
  site?: string,
  additionalHeaders?: RequestHeader,
  requestConfigs?: AxiosRequestConfig
): Promise<FiltersModel[]> => {
  const response = await new CoursesFiltersClient(
    host,
    privateHost,
    site,
    additionalHeaders,
    requestConfigs
  ).get();

  return response as unknown as Promise<FiltersModel[]>;
};
